export const SEARCH_DEBOUNCE_MS = 500;
export const ITEM_COUNT = 10;
export const COUNT_ALL = -1;
export const OFFSET_START = 0;
